import { writable } from 'svelte/store';
import { defaultAnimationStore, defaultAutomatonDimensionsStore, defaultColorStore, defaultDenerationControlsStore, defaultGenerationSettingsStore, defaultRule, defaultViewStore } from './defaults';
const animationStore = writable(defaultAnimationStore);
const automatonDimensionsStore = writable(defaultAutomatonDimensionsStore);
const automatonStore = writable(null);
const colorStore = writable(defaultColorStore);
const generationControlsStore = writable(defaultDenerationControlsStore);
const generationSettingsStore = writable(defaultGenerationSettingsStore);
const rule = writable(defaultRule);
const viewStore = writable(defaultViewStore);
export { animationStore, colorStore, rule, automatonStore, automatonDimensionsStore, generationSettingsStore, generationControlsStore, viewStore };
